import { Typography, useMediaQuery } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { USER_PROFILE_DATA } from '../../../api/url';
import { MuiStack } from '../../../components';
import { EDashboardtabName, LOCAL_STORAGE_KEYS } from '../../../constants';
import { setReducerState, setState } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import { JcKey } from '../../jobCard/services/jcEntity';
import { getUpdateKey } from '../../../builderPackage/common/commonFunctions';
var DashboardCountComponent = function (props) {
    var count = props.count, tabName = props.tabName, icon = props.icon, statusName = props.statusName, displayName = props.displayName;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var lgMode = useMediaQuery('(min-width:600px)');
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var localFromDate = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE);
    var localToDate = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE);
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var trackButtonClick = useAnalyticsEventTracker("DashboardCountComponent");
    var handleClick = function (tabName, statusName) {
        var req = {};
        var todaysDate = dateFormate(new Date());
        req = {
            // Status: statusName.map((itemlist: any) => itemlist.Key), // for paging
            Status: statusName,
            //for filter
            ModelId: "",
            ServiceAdvisorId: "",
            ServiceTypeId: "",
            BranchId: isAllViewActive ? "" : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            StartDocDate: localFromDate != null ? new Date(localFromDate) : new Date(todaysDate),
            EndDocDate: localToDate != null ? new Date(localToDate) : new Date(todaysDate)
        };
        var navigateToJobCard = function () {
            if ((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === "FinalInspector") {
                trackButtonClick("ButtonClickEvent", "Card_Click_Dashboard_FinalInspection", undefined);
                dispatch(setReducerState({
                    key: getUpdateKey("getFinalInspectorList"),
                    value: true
                }));
                navigate('/finalInspection');
            }
            else {
                trackButtonClick("ButtonClickEvent", "Card_Click_Dashboard_Jobcard", undefined);
                dispatch(setReducerState({
                    key: getUpdateKey(JcKey.JcPaging),
                    value: true
                }));
                console.log("selectedDesignation", selectedDesignation);
                navigate('/jobCard');
            }
        };
        // req.Status = statusName.confirmed
        dispatch(setState({
            key: "filterValue",
            value: req
        }));
        // dispatch(setState({ key: "fromDashboard", value: true }))
        if (tabName == EDashboardtabName.Appointments) {
            trackButtonClick("ButtonClickEvent", "Card_Click_Dashboard_Appointment", undefined);
            navigate('/appointment');
        }
        else if (tabName == EDashboardtabName.PreJC) {
            trackButtonClick("ButtonClickEvent", "Card_Click_Dashboard_Appointment", undefined);
            navigate('/appointment');
        }
        else if (tabName == EDashboardtabName.DraftJC) {
            trackButtonClick("ButtonClickEvent", "Card_Click_Dashboard_Inspection", undefined);
            navigate('/inspection');
        }
        else if (tabName === EDashboardtabName.Estimate) {
            trackButtonClick("ButtonClickEvent", "Card_Click_Dashboard_Estimate", undefined);
            navigate('/serviceEstimate');
        }
        else if (tabName == EDashboardtabName.JCOpened) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.ReadyForInvoice) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.Delivered) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.InProgress) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.WorkCompleted) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.WithFI) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.AllOpen) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.Pending) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.Rework) {
            navigateToJobCard();
        }
        else if (tabName == EDashboardtabName.Complete) {
            navigateToJobCard();
        }
        // buttonClickSpan.end()
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "card",
        sx: {
            cursor: 'pointer',
            border: '1px solid',
            borderColor: 'secondary.200',
            background: 'white',
            borderRadius: '10px',
            width: "100%"
        },
        direction: 'column',
        justifyContent: "space-between",
        alignItems: "center",
        padding: 2.5,
        gap: 3,
        onClick: function () { return handleClick(tabName, statusName); }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "".concat(tabName, "-card-total"),
        fontWeight: "strong",
        fontSize: 36,
        lineHeight: 1.5
    }, count), /*#__PURE__*/ React.createElement(Typography, {
        id: "card-name",
        color: "text.secondary",
        fontWeight: "medium"
    }, displayName === "Complete" ? "FI Completed" : displayName)));
};
export default DashboardCountComponent;
